export interface IDesignation{
  id:number;
  code: string;
  name:string;
  status:string;
  designation?: string;
}
